"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePublisherWithDefaultDriver = exports.makePublisher = exports.defaultDriverBehavior = exports.DriverBehavior = exports.pageSessionId = exports.testMetricsDriver = void 0;
const KatalMetrics = __importStar(require("@amzn/katal-metrics"));
const KatalMetricsDriverArrayCollector_1 = __importDefault(require("@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector"));
const KatalMetricsDriverConsoleLogJson_1 = __importDefault(require("@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson"));
const katal_metrics_driver_sushi_1 = __importDefault(require("@amzn/katal-metrics-driver-sushi"));
const uuid_1 = require("uuid");
// Unique id for everything that happens in the current loaded scope
exports.pageSessionId = uuid_1.v4();
exports.DriverBehavior = {
    // Logs all metrics to testMetricsDriver which you can use to test that your metrics would be sent
    // For an example of using that, see the tests written for metrics.ts
    CollectForTests: 'CollectForTests',
    // Logs metrics to the console, this is the default fallback if none of these values are provided.
    LogToConsole: 'LogToConsole',
    // Sends metrics to the 'test' sushi eel endpoint
    PublishToTest: 'PublishToTest',
    // Sends metrics to the 'prod' sushi eel endpoint
    PublishToProd: 'PublishToProd',
};
exports.defaultDriverBehavior = (environmentName) => {
    // TODO: These strings are taken from et-console-components.inferEnvironment; trying to avoid a circular dependency
    //  here, but I don't like hard-coding the strings
    switch (environmentName) {
        case 'prod':
            return exports.DriverBehavior.PublishToProd;
        case 'staging':
            return exports.DriverBehavior.PublishToTest;
        case 'test':
            return exports.DriverBehavior.CollectForTests;
        default:
            return exports.DriverBehavior.LogToConsole;
    }
};
// In the future, we may want to send these across to a logging endpoint, for now
// just log errors.
const metricsErrorConsoleHandler = (err) => console.error(err);
const makeDriver = (behavior) => {
    switch (behavior) {
        case exports.DriverBehavior.CollectForTests:
            exports.testMetricsDriver = new KatalMetricsDriverArrayCollector_1.default(metricsErrorConsoleHandler);
            return exports.testMetricsDriver;
        case exports.DriverBehavior.PublishToTest:
            return new katal_metrics_driver_sushi_1.default.Builder()
                .withDomainRealm('test', 'USAmazon')
                .withErrorHandler(metricsErrorConsoleHandler)
                .build();
        case exports.DriverBehavior.PublishToProd:
            return new katal_metrics_driver_sushi_1.default.Builder()
                .withDomainRealm('prod', 'USAmazon')
                .withErrorHandler(metricsErrorConsoleHandler)
                .build();
        default:
        case exports.DriverBehavior.LogToConsole:
            return new KatalMetricsDriverConsoleLogJson_1.default();
    }
};
exports.makePublisher = (siteName, serviceName, driverBehavior) => {
    const initialMetricsContext = new KatalMetrics.Context.Builder()
        .withSite(siteName)
        .withServiceName(serviceName)
        .withRelatedMetrics(new KatalMetrics.Metric.String('PageSessionId', exports.pageSessionId))
        .build();
    return new KatalMetrics.Publisher(makeDriver(driverBehavior), metricsErrorConsoleHandler, initialMetricsContext);
};
exports.makePublisherWithDefaultDriver = (siteName, serviceName, environment) => {
    return exports.makePublisher(siteName, serviceName, exports.defaultDriverBehavior(environment));
};
//# sourceMappingURL=publisher.js.map